import { useEffect } from 'react'
import { sum } from 'lodash-es'
import { estimateDriveTimeByRouteId } from '@/utils/scheduling'
import { DetailedDriveStatistics } from '@/api/main/types.gen'
import { ScheduledDriveInterval } from '@/utils/scheduling'
import { useSchedulerCalculationsStore } from '@/stores/schedulerCalculations'

export function useDriveCalculations(
  scheduledDriveIntervals: Record<string, ScheduledDriveInterval[]>,
  driveStatistics: DetailedDriveStatistics[]
) {
  const { setEstimatedTime, setDrivenTime } = useSchedulerCalculationsStore()

  useEffect(() => {
    Object.entries(scheduledDriveIntervals).forEach(([vehicleId, intervals]) => {
      const estimatedSeconds = sum(
        intervals.flatMap(({ drives }) => drives.map(drive => estimateDriveTimeByRouteId(drive)))
      )

      const elapsedSeconds = sum(
        intervals.flatMap(({ drives }) =>
          drives.map(drive => driveStatistics.find(stat => stat.drive_id === drive.id)?.duration_seconds ?? 0)
        )
      )

      setEstimatedTime(vehicleId, estimatedSeconds)
      setDrivenTime(vehicleId, elapsedSeconds)
    })
  }, [scheduledDriveIntervals, driveStatistics, setEstimatedTime, setDrivenTime])
}
